// src/pages/Admin/AdminLogin.js

import React, { useState } from "react";
import "../../styles/AdminLogin.css";
import { loginApi } from "../../lib/api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/colored-logo.png";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUser] = useState("");
  const [password, setPass] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      toast.error("Please enter both fields");
      return;
    }

    try {
      toast.loading("Authenticating...", { id: "adminlogin" });

      await loginApi(username, password);

      toast.success("Admin access granted", { id: "adminlogin" });

      navigate("/portal-admin/dashboard");
    } catch (err) {
      toast.error("Invalid admin credentials", {
        id: "adminlogin",
      });
    }
  };

  return (
    <div className="admin-login-screen">

      <img src={logo} alt="Hindsight Logo" className="admin-login-logo" />

      <div className="admin-login-box fade">

        <h2>Admin Login</h2>
        <p className="admin-login-subtitle">Welcome back!</p>

        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Admin Username"
            value={username}
            onChange={(e) => setUser(e.target.value)}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPass(e.target.value)}
          />

          <button className="btn-primary admin-login-btn" type="submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}
